import { translate, type Params } from './runtime';

/** Store a stable message key so a visible error changes with the UI language. */
export class LocalizedError extends Error {
  constructor(
    readonly namespace: string,
    readonly key: string,
    readonly params: Params = {},
    readonly status?: number,
  ) {
    super(key);
    this.name = 'LocalizedError';
  }
}

export function localizedErrorMessage(error: unknown, namespace: string, fallbackKey: string): string {
  if (error instanceof LocalizedError) return translate(error.key, error.params, error.namespace);
  if (error instanceof DOMException && error.name === 'AbortError') return translate('sessionChanged');
  // Never expose arbitrary API bodies in credential/consent flows.
  return translate(fallbackKey, {}, namespace);
}
